// src/components/SummaryChart.jsx
import {
  LineChart, Line, XAxis, YAxis,
  Tooltip, ResponsiveContainer, Legend
} from "recharts";

export default function SummaryChart({ data }) {
  return (
    <section className="bg-white rounded-card shadow-card p-4 mb-6">
      <h3 className="text-sm font-medium mb-4">
        District Submissions Overview
      </h3>

      <ResponsiveContainer height={320}> {/* ✅ Increased height */}
        <LineChart data={data}>
          <XAxis 
            dataKey="district" 
            tick={{fontSize:10}} 
            angle={-45}  
            textAnchor="end" 
            height={80}  
          />
          <YAxis />
          <Tooltip />
          <Legend />

          <Line
            type="monotone"
            dataKey="submissions"
            stroke="#16a34a"
            strokeWidth={3}
            dot={false}
            name="Submissions"
          />

          <Line
            type="monotone"
            dataKey="approved"
            stroke="#4ade80"
            strokeWidth={3}
            dot={false}
            name="Approved"
          />
        </LineChart>
      </ResponsiveContainer>
    </section>
  );
}